module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-7b6ffb66!./packages/dof-numcard-col/colmo.css
// module id = 523
// module chunks = 0 1